import CommonTable from "utilFunctions/shared/CommonTable/CommonTable";
interface FacultiesRegionsIC {
  loader: boolean;
  data: any[];
  tableHeading: any;
  sortColumn: string;
  sortOrder: string;
  setSortColumn: any;
  setSortOrder: any;
  screen: any;
}
const FacultiesRegions = ({
  loader,
  data,
  tableHeading,
  sortColumn,
  sortOrder,
  setSortColumn,
  setSortOrder,
  screen,
}: FacultiesRegionsIC) => {
  const extraInformation = {
    branchAndRegionIdentifier: true,
    regionId: null,
  };

  return (
    <>
      <CommonTable
        mode="studentHome"
        isTableLoader={loader}
        tableData={data}
        tableHeading={tableHeading}
        sortColumn={sortColumn}
        sortOrder={sortOrder}
        setSortColumn={setSortColumn}
        setSortOrder={setSortOrder}
        primaryMessage="Regions data not available"
        secondaryMessage=""
        className={
          ["xs", "sm", "md"].includes(screen) ? "facultyDivMB" : "feedbackTable"
        }
        sortingArray={[
          "unmarkedLectureCount",
          "overallRatingAvg",
          "numberOfFeedbacks",
          "totalFacultiesCount",
        ]}
        extraInformation={extraInformation}
      />
    </>
  );
};
export default FacultiesRegions;
